var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"fill":"#32BEA6","d":"M50 99.934c27.614 0 50-22.37 50-49.967C100 22.371 77.614 0 50 0S0 22.371 0 49.967s22.386 49.967 50 49.967z"}}),_c('path',{attrs:{"fill":"#fff","d":"M45.99 76.546L22.35 58.128l6.722-8.626 14.517 11.31 23.96-34.574 8.99 6.228-30.548 44.08z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }